import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CredentialInterface } from '@interface/credential/credential.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';

import { initialCredentialsState } from './credentials.initial-state';

export const credentialsSlice = createSlice({
  name: 'credentials',
  initialState: initialCredentialsState,
  reducers: {
    ...baseReducerActions(initialCredentialsState),
    setCredential: (state, { payload }: PayloadAction<ResponseDataInterface<CredentialInterface>>) => {
      state.data.push(payload.data);
    },
  },
});

export const credentialsActions = credentialsSlice.actions;
